import { Dropdown, IDropdownOption, SelectableOptionMenuItemType } from 'office-ui-fabric-react';
import React, { useState } from 'react';

import { EgApplicationVersion, EgTestScenario } from 'wsp-core/src/interfaces';
import { WsSelectedActions } from '../../../core';




const options: IDropdownOption[] = [
  // { key:  0,               text: 'Select Action',          itemType: SelectableOptionMenuItemType.Normal   },
  // { key: 'divider-1',      text: '-',                      itemType: SelectableOptionMenuItemType.Divider  },
  // { key: 'test-scenarios', text: manualTestScenariosText,  itemType: SelectableOptionMenuItemType.Header   },
  // { key: 1,               text: 'Ignore',     itemType: SelectableOptionMenuItemType.Normal  },
  { key: 1,               text: 'Activate',   itemType: SelectableOptionMenuItemType.Normal  },
  { key: 2,               text: 'Deactivate', itemType: SelectableOptionMenuItemType.Normal },
  // { key: 3,               text: 'Manual Test (Multiple)', itemType: SelectableOptionMenuItemType.Normal   }
];




type Props = {
  // children?: never;
  // applicationVersion: EgApplicationVersion;
  // selectedActions: WsSelectedActions;
  // setSelectedActions: React.Dispatch<React.SetStateAction<WsSelectedActions>>;
  // setSelectedApplicationVersion?: React.Dispatch<React.SetStateAction<EgApplicationVersion | undefined>>;
};

const WsDeliverActionSelect = (props: Props) => {

  // const testScenarios = props.applicationVersion.testScenarios || [];



  // const manualTestScenariosText = testScenarios.length > 0 ? 'Manual Test Scenarios' : 'Test Scenarios';

  



  // if (testScenarios.length > 0) {

  //   options.push(
  //     { key: 'divider-1',      text: '-',                        itemType: SelectableOptionMenuItemType.Divider },
  //     { key: 'test-scenarios', text: 'Automated Test Scenarios', itemType: SelectableOptionMenuItemType.Header  }
  //   );

  //   testScenarios.forEach((testScenario: EgTestScenario) => {
  //     if (testScenario.id) {
  //       options.push(
  //         { key: testScenario.id, text: testScenario.name, itemType: SelectableOptionMenuItemType.Normal }
  //       );
  //     }
  //   });
  // }



  const onChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined) => {

    // const selectedActions = { ...props.selectedActions };

    // if (option?.key === 0) {
    //   delete selectedActions[`${props.applicationVersion.id}`];

    // } else if (option?.key === -3) {
    //   delete selectedActions[`${props.applicationVersion.id}`];

    //   if (props.setSelectedApplicationVersion) {
    //     props.setSelectedApplicationVersion(props.applicationVersion);
    //   }

    // } else {
    //   selectedActions[`${props.applicationVersion.id}`] = option?.key;
    // }

    // props.setSelectedActions(selectedActions);
  };



  // const selectedAction = props.selectedActions[`${props.applicationVersion.id}`];

  return (
    <div className="ws-action-select">
      <Dropdown
        options={options}
        // onChange={onChange}
        placeholder="Select Action"
        // selectedKey={selectedAction || 0}
      />
    </div>
  );
};




export {
  WsDeliverActionSelect
};
